import { useEffect, useRef } from "react";
import { animated, SpringValue } from "react-spring";

// export const chromeVideoName = `/9-framesperfectloop2-infps16-outfps30-crf40-s1080.webm`
// export const chromeVideoName = `/r0000-0012-40samples.webm`;
export const chromeVideoName = `/manual-interpolation-padded-3-crf20-r36.webm`;
export const safariVideoName = `/manual-interpolation-padded-3-r36-2.mov`;

const Video = ({
  videoStyle,
  videoStartSecond,
  containerStyle,
}: {
  videoStyle: any;
  videoStartSecond?: number;
  containerStyle?: React.CSSProperties;
}) => {
  useEffect(() => {
    let video;

    const indexedDB = window.indexedDB;
    // open iocodb from indexedDB
    const request = indexedDB.open("iocodb", 1);

    // on error log
    request.onerror = function (event) {
      console.error("An error occurred with IndexedDB");
      console.error(event);
    };

    // onSuccess opening iocodb
    request.onsuccess = function () {
      // console.log("Database opened successfully");
      const db = request.result;
      const transaction = db.transaction("video", "readwrite");
      const store = transaction.objectStore("video");

      // get videoData
      const objectStoreRequest = store.get(1);

      // onSuccess getting video data stored in iocoDB
      objectStoreRequest.onsuccess = (event) => {
        video = objectStoreRequest.result;
        const url = URL.createObjectURL(video.data);
        // console.log({ url });
        // set video source to video data URL
        if (ref.current) {
          ref.current.src = url;
          // if (videoStartSecond) {
          //   ref.current.currentTime = videoStartSecond;
          // }
          // console.log(ref.current?.currentTime);
        }
      };
    };
  }, [videoStartSecond]);

  const ref = useRef<HTMLVideoElement>(null);

  return (
    <div
      id="video-Container"
      {...{
        style: {
          display: "grid",
          placeSelf: "center",
          ...containerStyle,
        },
      }}
    >
      <animated.video
        autoPlay
        muted
        playsInline
        loop
        style={{ ...videoStyle }}
        ref={ref}
      />
    </div>
  );
};

export { Video };
